import { getTableColumnsCount } from '../TruthTableUtils';
import './NoMatchesRow.less';
import { useContext } from 'react';
import { RuleDesignerContext } from 'domains/designers/RuleDesigner/RuleDesignerContext';
import { IRootGroupModel } from 'domains/designers/RuleDesigner/models/RootGroupModel';

interface INoMatchesRowProps {
  rootModel: IRootGroupModel;
}

/**
 * Rows indicates that there is no items for applied filter.
 *
 * @see TruthTableFilter
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function NoMatchesRow({ rootModel }: INoMatchesRowProps) {
  const { designerSurface } = useContext(RuleDesignerContext);

  return (
    <tr className="tt-table__row">
      <td colSpan={getTableColumnsCount(rootModel, designerSurface)}>
        <div className="tt-table__no-matches">No data matches applied filter</div>
      </td>
    </tr>
  );
}
